<h1>Exit Survey</h1>

<div class="card">
  <div class="card-header">
    <div>
      Exit Surveys for <a *ngIf="surveyDetails" [href]="memberProfileLink" target="_blank"
        [title]="surveyDetails.email">{{ surveyDetails.firstName + "
        " + surveyDetails.lastName + " (" +surveyDetails.codeId + ')' }}</a>
    </div>
    <div *ngIf="surveyDetails" class="cancelled-at">
      {{ cancelledAt }}
    </div>
  </div>
  <div class="card-block">
    <div class="loading-cont" *ngIf="loading">
      <div class="loading-spinner"></div>
    </div>
    <p class="no-items-found" *ngIf="!loading && !surveyDetails">No data.</p>
    <div *ngIf="!loading && surveyDetails" class="question-cards">
      <div *ngFor="let question of surveyDetails.questions" class="question-card">
        <div class="question-card-header">
          <span><strong>Q: {{ question.question }}</strong></span>
          <span><em>{{ questionType(question.type) }}</em></span>
        </div>
        <span><strong>A:</strong> {{ question.answers[0].value }}</span>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/exit-survey/exit-survey-details/exit-survey-details.component.html